import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { AdditionalCondition } from '../../biometrics-registration-wizard/models/models';

@Component({
    selector: 'app-individual-conditions-list',
    templateUrl: './conditions.component.html',
    styleUrls: ['./conditions.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ConditionsComponent {

	@Input()
	public isOpen = false;

	@Input()
	public conditions: Array<AdditionalCondition> | null;

	@Output()
	public titleClick = new EventEmitter();

	constructor() { }

	public onTitleClick() {
		this.titleClick.emit();
	}

}
